<template>
    <div
        v-show="show"
        id="paint-background"
        :style="boardStyle"
        @pointerover="handlePointerOver"
        @pointerleave="handlePointerLeave"
        @pointerenter="handlePointerEnter"
    >
        <span id="title" ref="title"></span>
        <img id="close" src="@/assets/art/paint_board/close.svg" @click="closeBoard" />

        <PaintSetting ref="paintSetting" />
    </div>
</template>

<script>
import DEFINE from "@/js/painter/define";
import { focusStore } from "@/js/store/nowFocusStore";
import PaintSetting from "./PaintSetting.vue";
import { store } from "../../store";
export default {
    name: "PaintBoard",
    data: function () {
        return {
            show: false,
            operate: DEFINE.OPERATE.PEN,
        };
    },
    methods: {
        closeBoard() {
            this.show = false;
        },
        updateBoard() {
            switch (this.operate) {
                case DEFINE.OPERATE.PEN:
                    this.$refs.title.innerText = "畫筆";
                    break;
                case DEFINE.OPERATE.HIGHLIGHTER:
                    this.$refs.title.innerText = "螢光筆";
                    break;
                case DEFINE.OPERATE.LASER_POINTER:
                    this.$refs.title.innerText = "雷射筆";
                    break;
                default:
                    break;
            }

            this.$refs.paintSetting.operate = this.operate;
            this.$refs.paintSetting.updateSetting();
        },
        handlePointerOver() {
            focusStore.setFocusPaintBoard(true);
        },
        handlePointerLeave() {
            focusStore.setFocusPaintBoard(false);
        },
        handlePointerEnter() {
            focusStore.setFocusPaintBoard(true);
        },
    },
    components: { PaintSetting },
    computed: {
        boardStyle() {
            let maxValue = Math.max(store.pageHeight * 0.13, 82);
            return { bottom: `${maxValue}px` };
        },
    },
};
</script>

<style src="../../assets/css/PaintBoard.css" scoped></style>
